const storeEquipmentService = {
  inactivateSuccess: 'Serviço desabilitado com sucesso',
  activateSuccess: 'Serviço habilitado com sucesso',
  inactivateError: 'Erro ao desabilitar o serviço',
  activateError: 'Erro ao habilitar o serviço',
}

export default storeEquipmentService;
